
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.267 17.98l.003-.006.003-.007a.67.67 0 00-.076-.683l-7.553-9.436V6.8h7.038a.649.649 0 00.591-.386.636.636 0 00-.13-.7l-1.478-1.48 1.46-1.462a.64.64 0 00.151-.714l-.003-.006a.649.649 0 00-.59-.385H10a.64.64 0 00-.643.644v5.537l-7.55 9.451-.004.004a.67.67 0 00-.076.684l.005.01.006.01a.671.671 0 00.58.327h15.364a.651.651 0 00.585-.354zM7.88 11.766L10 9.11l2.12 2.657L10 13.095l-2.12-1.329zm7.42-7.994c-.25.251-.26.665.003.906l.814.814h-5.473V2.936h5.492l-.835.836zm1.025 13.274H3.657l3.422-4.273 2.58 1.61a.587.587 0 00.341.106c.12 0 .233-.025.342-.105l2.579-1.611 3.404 4.273z","fill":"#1D3C6F"}})])
          )
        }
      }
    